import { render, staticRenderFns } from "./BusinessesView.vue?vue&type=template&id=3d4b36e8&scoped=true&"
import script from "./BusinessesView.vue?vue&type=script&lang=js&"
export * from "./BusinessesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4b36e8",
  null
  
)

export default component.exports